import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { Breadcrumbs } from '../../../../AbstractElements';
import AddUser from './AddUser';


const UserProfile = () => {

    const { id } = useParams();

    return (
        <Fragment>
            <Container fluid={true}>
                <div className="edit-profile">
                    <Row>
                        <Col xl="12">
                            <AddUser userid={id} />
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    );
};
export default UserProfile;